module.exports = __webpack_public_path__ + "img/img-bd552e.jpg";